<template>
	<div ref="CreateSearch" class="dialog-container">
		<div class="dialog scroll" style="transform: translate(0, -400px); max-width: 680px;">
			<form @submit.stop="doValidation()">
				<div class="center dialog-flex" style="margin: 0;">
					<div>
						<div style="display: flex; justify-content: space-between; align-items: center;">
							<span class="dialog-tag">참여자 검색</span>
						</div>
						<div style="display: flex; justify-content: space-between; align-items: center; margin-top: 16px; column-gap: 10px;">
							<select class="list-select" v-model="searchCategory" style="width: 130px;">
								<option value="">선택</option>
								<option value="참여자번호">참여자번호</option>
								<option value="참여자이름">참여자이름</option>
								<!-- <option value="데이터분류">데이터분류</option>
								<option value="상태">상태</option> -->
							</select>
							<input class="input-crud" type="text" style="width: 484px;" placeholder="참여자 번호 또는 이름을 검색하세요." v-model="searchText" v-on:keydown.enter.prevent='selectUserList()'>
							<div class="search-btn" @click.stop="selectUserList()">
								<img src="@/assets/images/home/search.png"/>
								검색
							</div>
						</div>
						<div style="height: 490px; position: relative; margin-top: 30px;">
							<div class="scroll" style="height: 420px; overflow-y: auto;">
								<table class="tb-crud-horizon popup-table">
									<colgroup>
										<col width="72px" />
										<col width="300px" />
										<col width="auto" />
									</colgroup>
									<tbody>
										<tr style="border-top: 1px solid #191C26">
											<th style="text-align: center; border-right: 1px solid #ddd;">선택</th>
											<th style="text-align: center; border-right: 1px solid #ddd;">참여자 번호</th>
											<th style="text-align: center;">참여자 이름</th>
										</tr>
										<template
											v-for="(user, index) in userList"
										>
											<tr
												:key="index"
											>
												<td style="border-left: none; text-align: center;"><input type="checkbox" @change="check(user)" :checked="selectChk(user.id)"></td>
												<td>
													{{ user.id }}
												</td>
												<td>
													{{ user.name }}
												</td>
											</tr>
										</template>
										<tr v-if="userList.length == 0">
											<td colspan="3" class="no-list" style="border: none; text-align: center;">
												참여자가 존재하지 않습니다.
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="pagination-wrap" style="bottom: 10px">
								<pagination
									:data="pagination"
									:show-disabled="true"
									:limit="4"
									@pagination-change-page="doSearchPage"
								>
									<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
									<button type="button" slot="next-nav" class="page-next">&gt;</button>
								</pagination>
							</div>
						</div>
					</div>
				</div>
				<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px;">
					<button type="button" class="btn-save" style="margin: 0;" title="Update" @click.stop="checkUser()">
						저장
					</button>
					<button type="button" class="btn-cancel" style="margin: 0;" title="Cancel" @click="doCancel()">
						닫기
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "CreateSearch",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
		this.selectUserList();
	},
	mounted(){
		this.$nextTick(function () {
			if(this.$parent.current_page != "" && this.$parent.current_page != undefined){
				this.doSearchPage(this.$parent.current_page);
			}
		});
	},
	watch: {
		searchText: function(val) {
			// this.item.pageName = val;
			this.item.searchText = val;
			this.item.pageNum = 1;
		},
		searchCategory: function(val) {
			// this.item.pageName = val;
			this.item.searchCategory = val;
			this.item.pageNum = 1;
		}
	},
	data() {
		return {
			userId: sessionStorage.getItem('userId'),
			userName: sessionStorage.getItem('userName'),
			item: {},
			isTab: 1,
			userList: [],
			pagination: {},
			searchText: "",
			searchCategory: "",
			selectId: "",
			selectName: "",
			selectRecordType: []
		};
	},
	components:{
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		check(user){
			this.selectId = user.id;
			this.selectName = user.name;
			this.selectRecordType = user.dataList;
		},
		selectChk(id){
			if(this.selectId == id){
				return true;
			}
			else{
				return false;
			}
		},
		checkUser(){
			this.$set(this.$parent.item, 'id', this.selectId);
			this.$set(this.$parent.item, 'name', this.selectName);
			this.$parent.recordTypeList = this.selectRecordType;
			this.doClose();
		},
		keyupHandler(event) {
			this.logger.debug(this, "keyupHandler(event)");
			// this.searchTextVal = event.target.value;
			if (event.keyCode == 13)
			{
				EventBus.$emit("project-loading", true);
				this.selectUserList();
			}
		},
		doSearchPage(page) {
			this.logger.debug(this, "doSearchPage()");
			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.item.pageNum = page;
			this.selectUserList();
		},
		selectUserList(){
			this.logger.debug(this, "selectUserList()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/collectData/selectCollectList.do", this.item)
				.then((response) => {
					console.log(response);
					this.userList = response.data.collectList;
					this.pagination = response.data.pagination;

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");

			axios
				.post(this.config.contextRoot + "/field/selectSortOrder.do", this.item)
				.then((response) => {
					console.log(response);

					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/field/insertGroup.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.selectProjectList();
							this.$parent.selectQuestionGroupList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.CreateSearch.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.CreateSearch.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isOpenSearch");
				this.$parent.isOpenSearch = false;
			}.bind(this), 410);
		},
		changeTap(type){
			this.isTab = type;
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.participant-tab-zone{
	width: 100%;
	height: 48px;
	margin-top: 20px;
	background-color: #EBF4FF;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.participant-btn{
	height: 40px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 18px;
	cursor: pointer;
}
.participant-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.participant-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.font-red{
	color: #F94848;
}
.font-yellow{
	color: #FFAD09;
}
</style>
